import { render, staticRenderFns } from "./GroupDetailContainer.vue?vue&type=template&id=c015f124&"
import script from "./GroupDetailContainer.vue?vue&type=script&lang=js&"
export * from "./GroupDetailContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports